import React, { useEffect, useState } from 'react';
import '../workflow-editor/workflowEditor.css';

import { Map as ImmutableMap } from 'immutable';
import { WorkflowGraph } from '../workflow-editor/workflow-graph';
import { WorkflowDisplay } from '../workflow-editor/WorkflowDisplay';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Row from '@amzn/meridian/row';
import Button from '@amzn/meridian/button';
import { buildSelectionAttributes } from '../../services/utils';

export const RevisionViewer = ({ workflowData, onClose }) => {
  const [workflowGraphs, setWorkflowGraphs] = useState([]);

  const [workflowSelectionAttributes, setWorkflowSelectionAttributes] = useState(new ImmutableMap());

  useEffect(() => {
    if (!workflowData || !workflowData.subWorkflows) {
      return;
    }
    setWorkflowGraphs(
      workflowData.subWorkflows.map(subWorkflow => {
        return new WorkflowGraph(subWorkflow);
      })
    );
    setWorkflowSelectionAttributes(buildSelectionAttributes(workflowData.selectorAttributes));
  }, [workflowData]);

  return (
    <Modal
      open={workflowData}
      title={`Viewing Workflow Revision from ${new Date(workflowData?.lastUpdatedTime).toLocaleString()}`}
    >
      <div className="w-100 h-100 p-1 d-flex flex-column">
        <WorkflowDisplay
          workflowData={workflowData}
          workflowGraphs={workflowGraphs}
          workflowSelectionAttributes={workflowSelectionAttributes}
        />
      </div>
      <ModalFooter>
        <Row alignmentHorizontal="right" widths="fit">
          <Button type="primary" size="small" onClick={onClose}>
            Close
          </Button>
        </Row>
      </ModalFooter>
    </Modal>
  );
};

export default RevisionViewer;
